module.exports = __webpack_public_path__ + "img/00634453001303.d25fe53d.png";